import { compose } from 'redux';
import { branch } from '../utils/general/branch';
import { withSubscription } from './helpersShared/withSubscription';

import {
	withDetailQuery,
	withModifyMutation,
} from './helpersDetailContainer';

export const DetailContainer = (WrappedComponent) => {
	return compose(
		withDetailQuery,
		branch(props => props.subscription, withSubscription),
		branch(props => props.modifyMutation, withModifyMutation),
	)(WrappedComponent);
};
